import React, { useState, useRef } from 'react';
import styles from './ReadMoreTag.module.css';

export const useReadMoreHandlers = () => {
  const [notify, setNotify] = useState(false);
  const timerRef = useRef({
    enterTimer: null,
    removeTimer: null,
    initialTimer: null,
  });

  const notifyExpandDescriptions = () => {
    setNotify(true);
    timerRef.current.removeTimer = setTimeout(() => {
      setNotify(false);
      timerRef.current.removeTimer = null;
    }, 2500);
    clearTimeout(timerRef.current.initialTimer);
    timerRef.current.initialTimer = null;
  };

  const handleMouseEnter = () => {
    handleMouseLeave();
    timerRef.current.initialTimer = setTimeout(() => {
      notifyExpandDescriptions();
    }, 1000);
    timerRef.current.enterTimer = setInterval(() => {
      notifyExpandDescriptions();
    }, 5000);
  };

  const handleMouseLeave = () => {
    if (timerRef.current.initialTimer) {
      clearTimeout(timerRef.current.initialTimer);
      timerRef.current.initialTimer = null;
    }
    if (timerRef.current.enterTimer) {
      clearInterval(timerRef.current.enterTimer);
      timerRef.current.enterTimer = null;
    }
    if (timerRef.current.removeTimer) {
      clearTimeout(timerRef.current.removeTimer);
      timerRef.current.removeTimer = null;
    }
    setNotify(false);
  };

  return {
    notify,
    handleMouseEnter,
    handleMouseLeave,
  };
};

const ReadMoreTag = ({ notify }) => {
  return (
    <span className={`${styles.readMore} ${notify ? styles.notify : ''}`}>
      Click on the card to explore
    </span>
  );
};

export default ReadMoreTag;
